import React from 'react'

const ChevronDownIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M8.36377 4.68213L5.18179 7.86411L1.99981 4.68213" stroke={props?.color ?? 'var(--primary)'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ChevronDownIcon